/* ==========================================================
   Hero Slider Banner - Logic
   Separated for security and performance.
========================================================== */
document.addEventListener('DOMContentLoaded', function() {
  function initSliders() {
    const sliders = document.querySelectorAll('.dyno-hero-slider');
   
    sliders.forEach(root => {
      // Prevent double initialization
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';


      const track = root.querySelector('.dyno-hero-track');
      const slides = root.querySelectorAll('.dyno-hero-slide');
      const prevBtn = root.querySelector('.dyno-hero-arrow.prev');
      const nextBtn = root.querySelector('.dyno-hero-arrow.next');
      const dots = root.querySelectorAll('.dyno-hero-dots .dot');


      let total = slides.length;
      if (total === 0) return;
      let index = 0;


      function update() {
        track.style.transform = 'translateX(' + (-index * 100) + '%)';
        if (dots && dots.length) {
          dots.forEach((d, i) => d.classList.toggle('active', i === index));
        }
        const activeSlide = slides[index];
        const vid = activeSlide.querySelector('video');
        if(vid) {
          vid.currentTime = 0;
          vid.play().catch(e => console.log(e));
        }
      }


      function prevSlide() { index = (index - 1 + total) % total; update(); resetAutoplay(); }
      function nextSlide() { index = (index + 1) % total; update(); resetAutoplay(); }
      function goToSlide(i) { index = i; update(); resetAutoplay(); }


      if (prevBtn) prevBtn.addEventListener('click', prevSlide);
      if (nextBtn) nextBtn.addEventListener('click', nextSlide);
      if (dots && dots.length) dots.forEach((d, i) => d.addEventListener('click', () => goToSlide(i)));


      // --- Swipe & Drag Logic ---
      let startX = 0;
      let isDown = false;


      root.addEventListener('touchstart', e => { startX = e.changedTouches[0].screenX; stopAutoplay(); }, {passive: true});
      root.addEventListener('touchend', e => { handleGesture(startX, e.changedTouches[0].screenX); startAutoplay(); }, {passive: true});
      root.addEventListener('mousedown', e => { startX = e.screenX; isDown = true; stopAutoplay(); e.preventDefault(); });
      root.addEventListener('mouseup', e => { if(!isDown) return; isDown = false; handleGesture(startX, e.screenX); startAutoplay(); });
      root.addEventListener('mouseleave', () => { if(isDown) { isDown = false; startAutoplay(); } });


      function handleGesture(start, end) {
        if (end < start - 50) nextSlide();
        if (end > start + 50) prevSlide();
      }


      // --- Autoplay Logic ---
      let autoplay = root.dataset.autoplay === 'true';
      let autoplaySpeed = parseInt(root.dataset.speed) || 5000;
      let autoplayTimer = null;
     
      function startAutoplay() {
        if (!autoplay || total <= 1 || autoplaySpeed === 0) return;
        stopAutoplay();
        autoplayTimer = setInterval(()=> nextSlide(), autoplaySpeed);
      }
      function stopAutoplay() {
        if (autoplayTimer) { clearInterval(autoplayTimer); autoplayTimer = null; }
      }
      function resetAutoplay() {
        if (autoplay) { stopAutoplay(); startAutoplay(); }
      }


      update();
      startAutoplay();
      root.addEventListener('mouseenter', stopAutoplay);
      root.addEventListener('mouseleave', startAutoplay);
    });
  }


  initSliders();
  document.addEventListener('shopify:section:load', initSliders);
});